const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressDisputed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-disputed",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c-0,7.727 -6.273,14 -14,14c-7.727,-0 -14,-6.273 -14,-14c-0,-7.727 6.273,-14 14,-14Zm-0,2.197c-6.514,0 -11.803,5.289 -11.803,11.803c0,6.514 5.289,11.803 11.803,11.803c6.514,-0 11.803,-5.289 11.803,-11.803c-0,-6.514 -5.289,-11.803 -11.803,-11.803Zm1.637,17.691c0,0.89 -0.722,1.612 -1.612,1.612c-0.891,0 -1.613,-0.721 -1.613,-1.612c0,-0.891 0.722,-1.613 1.613,-1.613c0.89,0.001 1.611,0.723 1.612,1.613Zm-2.687,-4.838l-0,-7.525c-0,-0.594 0.481,-1.075 1.075,-1.075c0.593,0 1.075,0.481 1.075,1.075l-0,7.525c-0,0.594 -0.482,1.075 -1.075,1.075c-0.594,0 -1.075,-0.481 -1.075,-1.075Z",
    style: {
      fill: "#d30000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressDisputed);
export default __webpack_public_path__ + "static/media/iconR-progress-disputed.c2a5d1c99cfd907248df317868914e68.svg";
export { ForwardRef as ReactComponent };